import { ProjectUpdateWithProject, PublicProject } from '../projects';

type LatestProjectUpdates = ProjectUpdateWithProject[];
type ProjectLocations = PublicProject[];

// These are carbon projects, with total avoided being specific
// to the user making the request
type SupportedProjects = Array<PublicProject & { totalCo2Avoided: number }>;

type SectionData = {
  latestProjectUpdates: LatestProjectUpdates;
  projectLocations: ProjectLocations;
  supportedProjects: SupportedProjects;
};

export type SectionType = keyof SectionData;
export type SectionPayload<T extends SectionType> = SectionData[T];

// functionally will operate in the same manner as the dashboard, with
// all sub-card data referencing a dictionary item by id so the response time
// of the endpoint is kept minimal by requesting all project metadata only once

// however data is server-side hydrated since there's a lot of project metadata
// going on here that would just be easier to do on the server
// get all relevant project ids --> fetch from the dictionary in one go --> hydrate responses
export type Payload = {
  [type in SectionType]: SectionPayload<type> | undefined;
};
